import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { RegisterComponent } from './pages/auth/register/register.component';
import { HistoryComponent } from './pages/history/history.component';
import { CeoComponent } from './pages/ceo/ceo.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { PreloaderComponent } from './layout/preloader/preloader.component';
import { FooterComponent } from './layout/footer/footer.component';
import { JobComponent } from './pages/job/job.component';
import { FactoryWorkerHkComponent } from './form/factory-worker-hk/factory-worker-hk.component';
import { ProgressComponent } from './form/factory-worker-hk/progress/progress.component';
import { ProgressStepComponent } from './form/factory-worker-hk/progress/progress-step/progress-step.component';
import { ProgressStepDirective } from './form/factory-worker-hk/progress/progress-step.directive';
import { ContactComponent } from './pages/contact/contact.component';
import { RecruitmentProcessComponent } from './pages/recruitment-process/recruitment-process.component';
import { OurDeploymentComponent } from './pages/our-deployment/our-deployment.component';
import { EngineeringAndConstructionComponent } from './pages/industries/engineering-and-construction/engineering-and-construction.component';
import { MedicalComponent } from './pages/industries/medical/medical.component';
import { HotelAndRestaurantComponent } from './pages/industries/hotel-and-restaurant/hotel-and-restaurant.component';
import { ManufacturingComponent } from './pages/industries/manufacturing/manufacturing.component';
import { MaintenanceDialogComponent } from './dialogs/maintenance-dialog/maintenance-dialog.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { GeneralInfoComponent } from './pages/general-info/general-info.component';

const routes: Routes = [
  { path: '', component: AppComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    HistoryComponent,
    CeoComponent,
    NavbarComponent,
    PreloaderComponent,
    FooterComponent,
    JobComponent,
    FactoryWorkerHkComponent,
    ProgressComponent,
    ProgressStepComponent,
    ProgressStepDirective,
    ContactComponent,
    RecruitmentProcessComponent,
    OurDeploymentComponent,
    EngineeringAndConstructionComponent,
    MedicalComponent,
    HotelAndRestaurantComponent,
    ManufacturingComponent,
    MaintenanceDialogComponent,
    GalleryComponent,
    GeneralInfoComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ModalModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
